import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Input,
  Form,
  Table
} from "reactstrap";
import i18n from "../../../i18n";
import { useDispatch } from "react-redux";
import Spinners from "../../../components/Common/Spinner";
import * as Yup from "yup";
import { useFormik } from "formik";
import SimpleAlertError from "../../../components/Alerts/SimpleAlertError";
import { delCostCenterEmployees } from "../../../helpers/api_rombo_helper";
import { map } from "lodash";
import { getCostCenterEmployees } from "../../../helpers/api_rombo_helper";
import StyledPagination from "../../../components/Common/StyledPagination";

const DeleteEmployeesModal = ({ selectCostCenter, isOpen, toggle, setShowAlertSuccess, setDeleteEmployeesModal, setTextHeader, setTextBody, reloadCostCenterEmployees, setReloadCostCenterEmployees, token }) => {

  const [checkAddEmployees, setCheckDelEmployees] = useState([]);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);
  const [opts, setOpts] = useState({});
  const [costCenterEmployees, setCostCenterEmployees] = useState({});
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    getEmployees()
  }, [dispatch]);

  useEffect(() => {
    initCheckBox()
    onCheckSelectEmployee()
  }, [costCenterEmployees]);

  useEffect(() => {
    if(document.getElementById("checkAll")){
      document.getElementById("checkAll").checked ? setCheckDelEmployees([]) : null
      document.getElementById("checkAll").checked = false
    }
  }, [isLoading]);

  const deletedEmployees = () => {
    let body = {
      employees: checkAddEmployees
    }
    delCostCenterEmployees(token, selectCostCenter.id, body)
      .then((response) => {
        setShowAlertSuccess(true)
        setDeleteEmployeesModal(false)
        setReloadCostCenterEmployees(!reloadCostCenterEmployees)
        setTextHeader(i18n.t("AddedEmployees"))
        setTextBody(i18n.t("SuccessAddEmployees", { name: selectCostCenter.name, number: checkAddEmployees.length }))
      })
      .catch((error) => {
        console.error("Error - delCostCenterEmployees - ", error)
        setErrorAlert(true)
        if(error.code == 500) setErrorAlertMessage(i18n.t("ServerError"))
        setErrorAlertMessage((error.response?.data?.detail || error.message))
      })
  }

  const getEmployees = (opts = {page: 1, size: 10}) => {
    getCostCenterEmployees(token, selectCostCenter.id, opts)
      .then((response) => {
        setOpts(opts)
        setCostCenterEmployees(response);
        setLoading(false)
      })
      .catch((error) => {
        console.error("Error - getCostCenterEmployees - ", error)
      })
  }

  const initCheckBox = () => {
    var checkboxes = document.getElementsByClassName("checksEmployees")
    for (let i = 0; i < checkboxes.length; i++) {
      checkboxes[i].checked = false
    }
  }

  const onCheckSelectEmployee = () => {
    checkAddEmployees.map((item) => document.getElementById(`check-${item.id}`) ? document.getElementById(`check-${item.id}`).checked = true : null)
  }

  const searchFilters = () => {
    var newOpts = {
      name: autoformik.values.name,
      email: autoformik.values.email,
      services: autoformik.values.services || 0
    }
    getEmployees(newOpts)
  }

  const autoformik = useFormik({
    initialValues: {
      search: "",
      email: "",
      employeeNumber: "",
      job: ""
    },
    validationSchema: Yup.object({
      search: Yup.string(),
      email: Yup.string(),
      employeeNumber: Yup.string(),
      job: Yup.string()
    })
  });

  const onClickAddEmployees = (args, type, e) => {    
    let addEmployees = checkAddEmployees
    if(type == "one"){
      if(e.target.checked){
        addEmployees.push({ id: args.id })
        setCheckDelEmployees(addEmployees)
      }
      else{
        let checkDeleteEmployee = addEmployees.filter(function(opt) { 
          return opt.id === args.id
        });
        if(checkDeleteEmployee.shift()){
          addEmployees.splice(addEmployees.indexOf(checkDeleteEmployee.shift()), 1);
        }
      }
    }else{
      let arrAddEmployees = []
      setCheckDelEmployees(arrAddEmployees);
      if(e.target.checked){
        costCenterEmployees.items.map((item) => {
          arrAddEmployees.push({ id: item.id })
          document.getElementById(`check-${item.id}`) ? document.getElementById(`check-${item.id}`).checked = true : null
        });
        setCheckDelEmployees([...arrAddEmployees])
      }
      else{
        costCenterEmployees.items.map((item) => {
          document.getElementById(`check-${item.id}`) ? document.getElementById(`check-${item.id}`).checked = false : null
        })
      }
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="RequestModal"
      style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      tabIndex="-1"
      toggle={toggle}
      backdrop={'static'}
      id="staticBackdrop"
      size={"xl"}
    >
      <div>
        <p className="cancellation-title">{i18n.t("DeleteEmployees")}</p>
        <div className="modal-separator"></div>
        <ModalBody className="mt-0 pt-0">
          <SimpleAlertError
            errorAlert={errorAlert}
            setErrorAlert={setErrorAlert}
            text={errorAlertMessage}
          />
          <Row className="pb-2">
            <Form className="row gy-2 gx-3 align-items-center" onSubmit={autoformik.handleSubmit}>
              <Col xxl={5} md={5} xs={12}>
                <div className="col-sm-auto">                        
                  <Input
                    type="text"
                    name="name"
                    className="form-control"
                    id="nameInput"
                    placeholder={i18n.t("SearchName")}
                    value={autoformik.values.name}
                    onBlur={(e) => {
                      autoformik.handleBlur(e);
                      searchFilters()
                    }}
                    onChange={(e) => {
                      autoformik.handleChange(e);
                      searchFilters()
                    }}
                    invalid={
                      autoformik.touched.name && autoformik.errors.name ? true : false
                    }
                  />
                  {
                    autoformik.errors.name && autoformik.touched.name ? (
                      <FormFeedback type="invalid">
                        {autoformik.errors.name}
                      </FormFeedback>
                    ) : null
                  }
                </div>
              </Col>
              {/* <Col xxl={2} md={2} xs={12}>
                <div className="col-sm-auto">
                  <Input type="text" name="employeeNumber" className="form-control" id="employeeNumberInput" placeholder={i18n.t("EmployeeNumber")}
                    value={autoformik.values.employeeNumber}
                    onBlur={(e) => {
                      autoformik.handleBlur(e);
                      searchFilters()
                    }}
                    onChange={(e) => {
                      autoformik.handleChange(e);
                      searchFilters()
                    }}
                    invalid={
                      autoformik.touched.employeeNumber && autoformik.errors.employeeNumber ? true : false
                    } />
                  {
                    autoformik.errors.employeeNumber && autoformik.touched.employeeNumber ? (
                      <FormFeedback type="invalid">{autoformik.errors.employeeNumber}</FormFeedback>
                    ) : null
                  }
                </div>
              </Col>
              <Col xxl={2} md={2} xs={12}>
                <div className="col-sm-auto">
                  <Label className="visually-hidden" htmlFor="statusInput">status</Label>
                  <Input type="text" name="email" className="form-control" id="emailInput" placeholder={i18n.t("Email")}
                    value={autoformik.values.email}
                    onBlur={(e) => {
                      autoformik.handleBlur(e);
                      searchFilters()
                    }}
                    onChange={(e) => {
                      autoformik.handleChange(e);
                      searchFilters()
                    }}
                    invalid={
                      autoformik.touched.email && autoformik.errors.email ? true : false
                    } />
                  {
                    autoformik.errors.email && autoformik.touched.email ? (
                      <FormFeedback type="invalid">{autoformik.errors.email}</FormFeedback>
                    ) : null
                  }
                </div>
              </Col>
              <Col xxl={3} md={3} xs={12}>
                <div className="col-sm-auto">
                  <Input type="text" name="job" className="form-control" id="jobInput" placeholder={i18n.t("Job")}
                    value={autoformik.values.job}
                    onBlur={(e) => {
                      autoformik.handleBlur(e);
                      searchFilters()
                    }}
                    onChange={(e) => {
                      autoformik.handleChange(e);
                      searchFilters()
                    }}
                    invalid={
                      autoformik.touched.job && autoformik.errors.job ? true : false
                    } />
                  {
                    autoformik.errors.job && autoformik.touched.job ? (
                      <FormFeedback job="invalid">{autoformik.errors.job}</FormFeedback>
                    ) : null
                  }
                </div>
              </Col> */}
            </Form>
          </Row>
          <Row>
            <Col>
              <div className="table-responsive pt-3">
                <Table className="table table-bordered mb-0">
                  <thead>
                    <tr>
                      <th className="table-header2">
                        <Input
                          type="checkbox"
                          id="checkAll"
                          name="checkAll"
                          onClick={(e) => onClickAddEmployees(null, "all", e)}
                        />
                      </th>
                      <th className="table-header2">{i18n.t("Name")}</th>
                      <th className="table-header2">{i18n.t("Email")}</th>
                      <th className="table-header2">{i18n.t("Status")}</th>
                      {/* <th>{i18n.t("Job")}</th> */}
                    </tr>
                  </thead>
                  {
                    isLoading ? null :
                      <tbody>
                        {map(costCenterEmployees.items, (employee, key) => (
                          <tr key={employee.id}>
                            <td scope="row">
                              <Input
                                type="checkbox"
                                id={`check-${employee.id}`}
                                className="checksEmployees"
                                name={`check-${employee.id}`}
                                onClick={(e) => onClickAddEmployees(employee, "one", e)}
                              />
                            </td>
                            <td>{employee.name}</td>
                            <td>{employee.email}</td>
                            <td>
                              <div
                                className={`employee-status ${
                                  employee.status === "ACTIVE"
                                    ? "employee-status-active"
                                    : "employee-status-inactive"
                                }`}
                              >
                                {i18n.t(employee.status)}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                  }
                </Table>
                {isLoading ? (
                  <Spinners setLoading={setLoading} />
                ) : (
                  <StyledPagination
                    setLoading={setLoading}
                    viewPaginations={5}
                    pages={costCenterEmployees.pages}
                    token={token}
                    listTable={setCostCenterEmployees}
                    methodCustom={getCostCenterEmployees}
                    id={selectCostCenter.id}
                    opts={opts}
                    page={costCenterEmployees.page}
                    total={costCenterEmployees.total}
                    size={costCenterEmployees.size}
                    paginationDiv="col-lg-12"
                    paginationClass="pagination pagination-rounded justify-content-end mt-3 mb-4 pb-1"
                  />
                )}
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn-users border"
            type="button"
            onClick={deletedEmployees}
          >
            {i18n.t("DeleteEmployees")}
          </Button>
          <Button
            className="btn-light"
            type="button"
            data-dismiss="modal"
            onClick={toggle}
          >
            {i18n.t("GoBack")}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  )
}

DeleteEmployeesModal.propTypes = {
  setShowAlertSuccess: PropTypes.func,
  setDeleteEmployeesModal: PropTypes.func,
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  setTextHeader: PropTypes.func,
  setTextBody: PropTypes.func,
  setReloadCostCenterEmployees: PropTypes.func,
  reloadCostCenterEmployees: PropTypes.bool,
  costCenterEmployees: PropTypes.object,
  selectCostCenter: PropTypes.object
}

export default DeleteEmployeesModal;
